import { PAGE_DOCUMENT_SCHEMA_VERSION, } from '../../document/types.js';
import { orderConfirmationPresets, orderConfirmationSchema } from '../order-confirmation/schema.js';
/**
 * The default thank-you page (22/09/2026) — one `order-confirmation` section, which IS the validated
 * confirmation design, with everything switched on.
 *
 * Two callers read it, and they must agree:
 *   - the BACKEND seeds a `(thank-you, default)` page per store from its own mirror of this document, so
 *     the page exists in the builder the moment a store does;
 *   - the STOREFRONT falls back to this when a store has no such row yet — a shop created before the
 *     template existed and not yet reached by the backfill. Without the fallback, the thank-you page would
 *     simply stop rendering for those shops, on the one screen a buyer checks their money on.
 *
 * @param locale the SHOP's language. It matters even though this section seeds no sentences: the document
 *   carries its own locale, and every other page builder in this folder learned the same lesson the hard
 *   way — a hardcoded `'fr'` turned an Arabic shop's page French.
 */
export function buildThankYouPageDocument(locale = 'fr') {
    return {
        schemaVersion: PAGE_DOCUMENT_SCHEMA_VERSION,
        template: 'thank-you',
        handle: 'default',
        locale,
        sections: [
            {
                id: 'order-confirmation',
                type: 'order-confirmation',
                version: orderConfirmationSchema.version,
                settings: { ...orderConfirmationPresets[0]?.settings },
                blocks: [],
            },
        ],
    };
}
//# sourceMappingURL=thankYouPage.js.map